/**
 * Загрузка открытой организации — общий кусок для всех экранов кабинета.
 *
 * Живёт здесь, а не в каждом экране, по одной причине: почти всё в кабинете зависит от
 * полей организации — `tz` для календаря, `cancelWindowHours` и лимиты для «Правил»,
 * `type` для отраслевого названия специалиста, `isPublished` для кнопки публикации.
 * Пять копий одного запроса разъехались бы в том, что делать при отказе.
 *
 * ПРАВИЛА НЕ ЧИТАЮТСЯ ИЗ ПРЕСЕТА ОТРАСЛИ. Пресет копируется в строку организации при
 * создании и после этого не читается (AGENTS.md, правило 5): владелец мог поднять окно
 * отмены с 2 до 24 часов, и показать ему пресетные 2 значило бы соврать про его же
 * настройку. Пресет годится только для названия специалиста и иконки отрасли — того,
 * что в строке организации не хранится.
 */

import { useCallback } from 'react';
import type { CabinetBusinessDto } from '../../api/cabinetTypes';
import { useAppApi } from '../../app/ApiProvider';
import { useAsync, type AsyncState } from '../../hooks/useAsync';

export interface BusinessLoad {
  readonly state: AsyncState<CabinetBusinessDto>;
  /** `null`, пока грузится или если отказ. Экран обязан отрисовать состояние из `state`. */
  readonly business: CabinetBusinessDto | null;
  readonly reload: () => void;
}

export function useBusiness(businessId: string): BusinessLoad {
  const api = useAppApi();
  const load = useCallback(() => api.cabinet.getBusiness(businessId), [api, businessId]);
  const { state, reload } = useAsync(load, [businessId]);

  return {
    state,
    business: state.status === 'ready' ? state.data : null,
    reload,
  };
}
